/**
 * @generated SignedSource<<781316cf3f010541b46a7604a97f512c>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { Fragment, ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type SbSharedThinBrowseItemTrackingProvider_itemSearch$data = {
  readonly searchTerm: string | null;
  readonly " $fragmentSpreads": FragmentRefs<"ecommerceTracking_itemSearch">;
  readonly " $fragmentType": "SbSharedThinBrowseItemTrackingProvider_itemSearch";
};
export type SbSharedThinBrowseItemTrackingProvider_itemSearch$key = {
  readonly " $data"?: SbSharedThinBrowseItemTrackingProvider_itemSearch$data;
  readonly " $fragmentSpreads": FragmentRefs<"SbSharedThinBrowseItemTrackingProvider_itemSearch">;
};

const node: ReaderFragment = (function(){
var v0 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "searchTerm",
  "storageKey": null
};
return {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "SbSharedThinBrowseItemTrackingProvider_itemSearch",
  "selections": [
    (v0/*: any*/),
    {
      "kind": "InlineDataFragmentSpread",
      "name": "ecommerceTracking_itemSearch",
      "selections": [
        {
          "alias": null,
          "args": null,
          "kind": "ScalarField",
          "name": "pageType",
          "storageKey": null
        },
        (v0/*: any*/),
        {
          "alias": null,
          "args": null,
          "concreteType": "ItemSearchSponsored",
          "kind": "LinkedField",
          "name": "sponsored",
          "plural": false,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "ItemSearchSponsoredMetadata",
              "kind": "LinkedField",
              "name": "metadata",
              "plural": true,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "itemId",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "impressionTrackerLink",
                  "storageKey": null
                },
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "clickTrackerLink",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "args": null,
      "argumentDefinitions": []
    }
  ],
  "type": "ItemSearchQueryConnection",
  "abstractKey": null
};
})();

(node as any).hash = "c28831b0c214dc4a6be924b8a7004aca";

export default node;
